import { render } from "./routehome.vue?vue&type=template&id=268f2d32"
import script from "./routehome.vue?vue&type=script&lang=js"
export * from "./routehome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__